<template>
  <el-dialog title="收货地址" :visible.sync="SincouponDetailVisable">
    <el-table :data="gridData">
      <el-table-column property="date" label="日期" width="150"></el-table-column>
      <el-table-column property="name" label="姓名" width="200"></el-table-column>
      <el-table-column property="address" label="地址"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './couponhistory-add-or-update'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sms/signcoupon/getHistory',
          getDataListIsPage: true,
          exportURL: '/sms/couponhistory/export',
          deleteURL: '/sms/couponhistory',
          deleteIsBatch: true
        },
        dataForm: {
          id: '',
          memberId:''
        },
        gridData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
      }
    },
    components: {
      AddOrUpdate
    },
    methods:{
      init(memberId){
        this.$http.get('/ums/memberbalance/getHomePageData').then(({data: res}) => {
          console.log(res)
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.homePageData = res.data
          console.info(this.homePageData)
        }).catch(() => {
        })
      }
    }
  }
</script>
